import Vue from 'vue'
import store from './store';
import Router from 'vue-router'
import Landing from './views/Landing.vue'

import WizardBase from './views/wizard/Base.vue'
import WizardBuyRent from './views/wizard/BuyRent.vue'
import WizardPropertyType from './views/wizard/PropertyType.vue'
import WizardLocation from './views/wizard/Location.vue'
import WizardPriceRange from './views/wizard/PriceRange.vue'

import AccountBase from './views/account/Base.vue'
import AccountIntro from './views/account/Intro.vue'
import AccountLogin from './views/account/Login.vue'
import AccountLogout from './views/account/Logout.vue'
import AccountCreate from './views/account/Create.vue'
import AccountSignUp from './views/account/Signup.vue'
import AccountActivate from './views/account/Activate.vue'
import AccountVerify from './views/account/Verify.vue'
import AccountResetPassword from './views/account/ResetPassword.vue'
import AccountForgotPassword from './views/account/ForgotPassword.vue'

import Properties from './views/properties/Properties.vue'
import PropertiesEnquire from './views/properties/Enquire.vue'
import PropertyDetail from './views/properties/Property.vue'

import UserFavourites from './views/user/Favourites.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },

    {
      path: '/wizard',
      redirect: '/wizard/buy-rent',
      name: 'Wizard',
      component: WizardBase,
      children: [
        {
          path: 'buy-rent',
          name: 'BuyRent',
          component: WizardBuyRent
        },
        {
          path: 'property-type',
          name: 'PropertyType',
          component: WizardPropertyType
        },
        {
          path: 'location',
          name: 'Location',
          component: WizardLocation
        },
        {
          path: 'price-range',
          name: 'PriceRange',
          component: WizardPriceRange
        },
      ]
    },

    {
      path: '/account',
      redirect: '/account/intro',
      name: 'Account',
      component: AccountBase,
      children: [
        {
          path: 'intro',
          name: 'Intro',
          component: AccountIntro,
          beforeEnter: (to, from, next) => {
            if (store.state.user.authenticated) return next('/wizard');

            next();
          }
        },
        {
          path: 'login',
          name: 'Login',
          component: AccountLogin
        },
        {
          path: 'logout',
          name: 'Logout',
          component: AccountLogout
        },
        {
          path: 'create',
          name: 'Create',
          component: AccountCreate
        },
        {
          path: 'sign-up',
          name: 'Sign Up',
          component: AccountSignUp
        },
        {
          path: 'activate',
          name: 'Activate',
          component: AccountActivate
        },
        {
          path: 'verify/:token',
          name: 'Verify',
          component: AccountVerify,
          props: true
        },
        {
          path: 'reset-password/:token',
          name: 'ResetPassword',
          component: AccountResetPassword,
          props: true
        },
        {
          path: 'forgot-password',
          name: 'ForgotPassword',
          component: AccountForgotPassword
        },
      ]
    },

    {
      path: '/properties',
      name: 'Properties',
      component: Properties
    },
    {
      path: '/properties/enquire/:id',
      name: 'PropertiesEnquire',
      component: PropertiesEnquire,
      props: true
    },
    {
      path: '/properties/:id',
      name: 'PropertyDetail',
      component: PropertyDetail,
      props: true
    },

    {
      path: '/user',
      redirect: '/user/favourites'
    },
    {
      path: '/user/favourites',
      name: 'Favourites',
      component: UserFavourites
    },
  ],
  
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
